// Bluetooth scanning is replaced by a single virtual device: the browser
// print dialog. It is announced the same way a discovered printer would be.
import emitter from "./emitter";

export const BROWSER_PRINTER = {
  id: "BROWSER-PRINTER",
  name: "Browser Printer",
};

export default {
  start: () => Promise.resolve(),
  scan() {
    setTimeout(
      () => emitter.emit("BleManagerDiscoverPeripheral", BROWSER_PRINTER),
      300,
    );
    return Promise.resolve();
  },
  stopScan: () => Promise.resolve(),
  enableBluetooth: () => Promise.resolve(),
};
